//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as cardCouponApi from '@/api/cardCouponApi';
export default {
  name: 'PriceRecordsDialog',
  data: function data() {
    return {
      visible: false,
      loading: false,
      records: [],
      parkingCardId: null
    };
  },
  methods: {
    open: function open(parkingCardId) {
      this.parkingCardId = parkingCardId;
      this.visible = true;
      this.loadRecords();
    },
    loadRecords: function loadRecords() {
      var _this = this;
      if (!this.parkingCardId) {
        this.records = [];
        return;
      }
      this.loading = true;
      cardCouponApi.getPriceAdjustmentRecords(this.parkingCardId).then(function (data) {
        _this.records = data || [];
        _this.loading = false;
      }).catch(function () {
        _this.$message.error('获取调价记录失败');
        _this.records = [];
        _this.loading = false;
      });
    },
    closeDialog: function closeDialog() {
      this.visible = false;
    }
  }
};